import "./logo.css";

export default function Logo() {
  return (
    <div className="logo-container">
      <img src="image/logo.png" alt="" />
    </div>
  );
}
